$(document).ready(function() {
	$('body').addClass('vi-length-little');

	$(document).on('click', '.js-vi-length-little', function() {
		$('body').addClass('vi-length-little');
		$('body').removeClass('vi-length-medium');
		$('body').removeClass('vi-length-big');
	});

	$(document).on('click', '.js-vi-length-medium', function() {
		$('body').removeClass('vi-length-little');
		$('body').addClass('vi-length-medium');
		$('body').removeClass('vi-length-big');
	});

	$(document).on('click', '.js-vi-length-big', function() {
		$('body').removeClass('vi-length-little');
		$('body').removeClass('vi-length-medium');
		$('body').addClass('vi-length-big');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/length.js